import React from 'react';
import {IBouquet} from "../../../../entities/bouquets/api/types";
import {BouquetCard} from "../../../../entities/bouquets";

interface BouquetsListProps {
    bouquets?: IBouquet[];
    [key: string]: any;
}

export const BouquetsList: React.FC<BouquetsListProps | any> = (props) => {
    let list: IBouquet[] = [];

    if (Array.isArray(props)) {
        list = props;
    } else if (props && Array.isArray(props.bouquets)) {
        list = props.bouquets;
    } else if (props && typeof props === 'object') {
        list = Object.values(props).filter(
            (item): item is IBouquet => Boolean(item && typeof item === 'object' && 'id' in item)
        );
    }

    return (
        <div className="bouquet-grid">
            {list.map((bouquet) => (
                <BouquetCard key={bouquet.id} {...bouquet} />
            ))}
        </div>
    );
};
